const CirclifulPlugin = {
    init: ($) => {
        $('[data-plugin="circliful"]').each(() => $(this).circliful());
    },
};

export default CirclifulPlugin;
